<header>
    <h2 class="mb-20">{{title}}</h2>

    <div class="modal-close-icon" [class.brand-modal]="isBrandModal" (click)="cancel.emit()">
        <i nz-icon nzType="close"></i>
    </div>
</header>
